import { useParams } from 'react-router-dom';

import { ErrorMessage } from '@Components';
import ScheduleDetailContainer from './scheduleDetail.container';

interface ScheduleWrapperProps {
  view?: 'configuration';
}

const ScheduleWrapper = ({ view }: ScheduleWrapperProps) => {
  const { scheduleId } = useParams();

  if (!scheduleId) {
    return <ErrorMessage internalMessage="Unable to get schedule" />;
  }
  return <ScheduleDetailContainer key={scheduleId} scheduleId={scheduleId} view={view} />;
};

export default ScheduleWrapper;
